"use client";

/**
 * Global error boundary. Without this, uncaught errors in production
 * produce a text/plain response which triggers Next.js E789
 * ("Expected RSC response, got text/plain") on RSC requests.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="de">
      <body className="flex min-h-screen items-center justify-center bg-amber-50">
        <div className="mx-auto max-w-md px-4 text-center">
          <h2 className="mb-4 text-2xl font-bold text-slate-800">
            Etwas ist schiefgelaufen
          </h2>
          <p className="mb-6 text-slate-600">
            Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es
            erneut.
          </p>
          {error.digest && (
            <p className="mb-4 font-mono text-xs text-slate-400">
              Fehler-ID: {error.digest}
            </p>
          )}
          <button
            onClick={reset}
            className="rounded-full bg-amber-400 px-6 py-3 font-semibold text-slate-900 transition-colors hover:bg-amber-300"
          >
            Erneut versuchen
          </button>
        </div>
      </body>
    </html>
  );
}
